import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CookieManager from '../../../CookieManager';

const UnpaidEntry = ({ code, caption, endpoint }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [azienda, setAzienda] = useState("");
  const [header, setHeader] = useState(null);
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState([]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) {
      setError("Seleziona un file");
      return;
    }

    setError(null);
    setFile(selectedFile);
  };

  const doSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setError("Seleziona un file");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("reportCode", code);

      const response = await fetch(endpoint, {
        method: "POST",
        headers: CookieManager.authHeader(),
        body: formData
      });

      if (!response.ok) {
        setError("Errore durante il caricamento.");
        return;
      }

      const data = await response.json();

      console.log(data);

      setAzienda(data.azienda);
      setHeader(data.header);
      setRows(data.rows);
    }
    catch (err) {
      console.error(err);
      setError("Errore durante il caricamento.");
    }
  };


  const formatDate = (value) => {
    if (!value) return "";

    return new Date(value).toLocaleDateString("it-IT");
  };

  const formatCurrency = (value) => {
    if (value == null) return "";

    return Number(value).toLocaleString("it-IT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const toggleRow = (index) => {
    setSelected(prev =>
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  const toggleAll = () => {
    if (selected.length === rows.length) {
      setSelected([]);
      return;
    }

    setSelected(rows.map((_, index) => index));
  };

  const sendEmails = async () => {
    const selectedRows = selected.map(index => rows[index]);

    const body = JSON.stringify({
      azienda,
      idBanca: header.idBanca,
      descBanca: header.descBanca,
      iban: header.iban,
      rows: selectedRows
    });

    // console.log(body);
    // return;

    try {
      const response = await fetch("/stats/unpaid-send-mails", {
        method: "POST",
        headers: {
          ...CookieManager.authHeader(),
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          azienda,
          idBanca: header.idBanca,
          descBanca: header.descBanca,
          iban: header.iban,
          rows: selectedRows
        })
      });

      if (!response.ok) {
        alert("Errore durante l'invio.");
        return;
      }

      alert(`${selectedRows.length} mail inviate con successo.`);
      setSelected([]);
    }
    catch (err) {
      console.error(err);
      alert("Errore durante l'invio.");
    }
  };

  return (

    <div className="container my-5">
      <div className="card p-3">
        <h5 className="card-title">{caption}</h5>

        <form>
          <div className="row align-items-end">
            <div className="col-md-6 mb-3 position-relative">
              <input
                type="file"
                className={`form-control ${error ? 'is-invalid' : ''}`}
                accept=".csv"
                onChange={handleFileChange}
              />

              {error && <div className="invalid-tooltip">{error}</div>}
            </div>

            <div className="col-md-6 mb-3 text-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={doSubmit}
              >
                <FontAwesomeIcon icon="upload" />
                Carica
              </button>
            </div>
          </div>
        </form>

        {header && (
          <table className="table table-borderless table-sm mb-0">
            <tbody>
              <tr>
                <th style={{ width: "150px" }}>Azienda</th>
                <td>{azienda}</td>
              </tr>
              <tr>
                <th>Banca</th>
                <td>{header.idBanca} - {header.descBanca}</td>
              </tr>
              <tr>
                <th>IBAN per saldo</th>
                <td>{header.iban}</td>
              </tr>
            </tbody>
          </table>
        )}

        {rows.length > 0 && (
          <div className="table-responsive mt-4">

            {selected.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mb-3">
                <strong>
                  {selected.length} {selected.length === 1 ? "riga selezionata" : "righe selezionate"}
                </strong>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={sendEmails}
                >
                  <FontAwesomeIcon icon="paper-plane" /> Invia mail
                </button>
              </div>
            )}
            <table className="table table-sm table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "40px" }}>
                    <input
                      type="checkbox"
                      checked={rows.length > 0 && selected.length === rows.length}
                      onChange={toggleAll}
                    />
                  </th>

                  <th>Cliente</th>
                  <th>Fattura</th>
                  <th>Pagamento</th>
                  <th>Importo</th>
                  <th>Agente</th>
                  <th>Mail</th>
                </tr>
              </thead>

              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(index)}
                        onChange={() => toggleRow(index)}
                      />
                    </td>

                    <td>
                      {row.codiceRif} - {row.debitore}
                    </td>

                    <td>
                      {row.annoDoc}/{row.numDoc}
                      {row.serieDoc ? `/${row.serieDoc}` : ""}
                    </td>

                    <td>
                      {row.codPag} - {row.desPag}
                    </td>

                    <td className="text-end">
                      {formatCurrency(row.totDoc)}
                    </td>

                    <td>{row.desAge}</td>

                    <td>{row.mailAge}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnpaidEntry;